var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var _a, _b;
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Send as SendIcon, Visibility as VisibilityIcon, VisibilityOff as VisibilityOffIcon } from '@mui/icons-material';
import { Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, InputAdornment, TextField, Typography } from '@mui/material';
import { useSnackbar } from 'notistack';
import { useState } from 'react';
import { assinarEEnviarFolha } from '../fechamento_mensal_service';
import { getDadosUsuarioLogadoLocalStorage } from '../../../../services/mt_login';
var URL_MT_LOGIN = (_a = process.env.URL_MT_LOGIN) !== null && _a !== void 0 ? _a : '';
var MT_CLIENT_ID = (_b = process.env.MT_CLIENT_ID) !== null && _b !== void 0 ? _b : '';
/**
 * Reautentica a senha do usuário logado contra o Keycloak usando grant_type=password.
 * Retorna true se a senha for válida, false caso contrário.
 */
var reautenticarSenha = function (senha) { return __awaiter(void 0, void 0, Promise, function () {
    var usuarioLogado, username, url, resp, _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _b.trys.push([0, 2, , 3]);
                usuarioLogado = getDadosUsuarioLogadoLocalStorage();
                if (!usuarioLogado)
                    return [2 /*return*/, false];
                username = usuarioLogado === null || usuarioLogado === void 0 ? void 0 : usuarioLogado.cpf;
                if (!username)
                    return [2 /*return*/, false];
                url = "".concat(URL_MT_LOGIN, "/auth/realms/mt-realm/protocol/openid-connect/token");
                return [4 /*yield*/, fetch(url, {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                        body: new URLSearchParams({
                            grant_type: 'password',
                            client_id: MT_CLIENT_ID,
                            username: username,
                            password: senha,
                        }),
                    })];
            case 1:
                resp = _b.sent();
                return [2 /*return*/, resp.status >= 200 && resp.status < 300];
            case 2:
                _a = _b.sent();
                return [2 /*return*/, false];
            case 3: return [2 /*return*/];
        }
    });
}); };
export function ModalAssinarEnviar(_a) {
    var _this = this;
    var open = _a.open, onClose = _a.onClose, folhaId = _a.folhaId, onSucesso = _a.onSucesso;
    var enqueueSnackbar = useSnackbar().enqueueSnackbar;
    var _b = useState(''), senha = _b[0], setSenha = _b[1];
    var _c = useState(false), mostrarSenha = _c[0], setMostrarSenha = _c[1];
    var _d = useState(''), erroSenha = _d[0], setErroSenha = _d[1];
    var _e = useState(false), erroVazio = _e[0], setErroVazio = _e[1];
    var _f = useState(false), processando = _f[0], setProcessando = _f[1];
    var resetarEstado = function () {
        setSenha('');
        setMostrarSenha(false);
        setErroSenha('');
        setErroVazio(false);
        setProcessando(false);
    };
    var handleCancelar = function () {
        resetarEstado();
        onClose();
    };
    var handleAssinarEnviar = function () { return __awaiter(_this, void 0, void 0, function () {
        var senhaValida, resultado, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!senha.trim()) {
                        setErroVazio(true);
                        setErroSenha('');
                        return [2 /*return*/];
                    }
                    setErroVazio(false);
                    setErroSenha('');
                    setProcessando(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 4, , 5]);
                    return [4 /*yield*/, reautenticarSenha(senha)];
                case 2:
                    senhaValida = _a.sent();
                    if (!senhaValida) {
                        setErroSenha('Senha incorreta. Verifique sua senha e tente novamente.');
                        setSenha('');
                        setProcessando(false);
                        return [2 /*return*/];
                    }
                    if (!folhaId) {
                        setProcessando(false);
                        return [2 /*return*/];
                    }
                    return [4 /*yield*/, assinarEEnviarFolha(folhaId)];
                case 3:
                    resultado = _a.sent();
                    if ((resultado === null || resultado === void 0 ? void 0 : resultado.Status) === 'ERRO') {
                        setErroSenha((resultado === null || resultado === void 0 ? void 0 : resultado.Mensagem) || 'Erro ao processar a assinatura. Tente novamente.');
                        setProcessando(false);
                        return [2 /*return*/];
                    }
                    enqueueSnackbar('Folha assinada e enviada à FUNAC com sucesso.', {
                        variant: 'success',
                        anchorOrigin: { vertical: 'top', horizontal: 'right' },
                    });
                    resetarEstado();
                    onSucesso(resultado);
                    return [3 /*break*/, 5];
                case 4:
                    error_1 = _a.sent();
                    console.error('Erro ao assinar e enviar folha:', error_1);
                    setErroSenha('Falha de comunicação com o servidor. Tente novamente.');
                    setProcessando(false);
                    return [3 /*break*/, 5];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    return (_jsxs(Dialog, __assign({ open: open, onClose: undefined, fullWidth: true, maxWidth: 'xs', PaperProps: { sx: { borderRadius: 3, overflow: 'hidden' } } }, { children: [_jsx(DialogTitle, __assign({ sx: { pb: 0.5 } }, { children: _jsx(Typography, __assign({ variant: 'h6', sx: { fontWeight: 800, color: '#16a34a', fontSize: '1.1rem' } }, { children: "Assinar e Enviar Folha" })) })), _jsxs(DialogContent, __assign({ sx: { pt: 2, px: 3 } }, { children: [_jsx(Typography, __assign({ variant: 'body2', sx: {
                            color: '#4b5563',
                            fontSize: '0.85rem',
                            lineHeight: 1.6,
                            mb: 3,
                        } }, { children: "Para confirmar o envio, informe sua senha de acesso ao sistema. Ap\u00F3s o envio, a folha ficar\u00E1 bloqueada para edi\u00E7\u00F5es." })), _jsx(Typography, __assign({ variant: 'caption', sx: {
                            display: 'block',
                            mb: 0.5,
                            fontWeight: 700,
                            color: '#374151',
                            textTransform: 'uppercase',
                            fontSize: '0.7rem',
                        } }, { children: "SENHA DO SISTEMA *" })), _jsx(TextField, { id: 'campo-senha-assinatura', type: mostrarSenha ? 'text' : 'password', placeholder: 'Digite sua senha...', variant: 'outlined', size: 'small', fullWidth: true, value: senha, disabled: processando, onChange: function (e) {
                            setSenha(e.target.value);
                            if (erroVazio)
                                setErroVazio(false);
                            if (erroSenha)
                                setErroSenha('');
                        }, onKeyDown: function (e) {
                            if (e.key === 'Enter')
                                handleAssinarEnviar();
                        }, error: erroVazio || !!erroSenha, sx: {
                            backgroundColor: 'white',
                            '& .MuiOutlinedInput-root': {
                                '&.Mui-error fieldset': { borderColor: '#ef4444' },
                            },
                        }, InputProps: {
                            endAdornment: (_jsx(InputAdornment, __assign({ position: 'end' }, { children: _jsx(IconButton, __assign({ size: 'small', onClick: function () { return setMostrarSenha(!mostrarSenha); }, edge: 'end', tabIndex: -1 }, { children: mostrarSenha ? _jsx(VisibilityOffIcon, { sx: { fontSize: 18, color: '#9ca3af' } }) : _jsx(VisibilityIcon, { sx: { fontSize: 18, color: '#9ca3af' } }) })) }))),
                        } }), erroSenha && (_jsx(Typography, __assign({ variant: 'caption', sx: {
                            display: 'block',
                            mt: 1,
                            color: '#ef4444',
                            fontWeight: 600,
                            fontSize: '0.75rem',
                        } }, { children: erroSenha })))] })), _jsxs(DialogActions, __assign({ sx: { px: 3, py: 2, borderTop: '1px solid #e5e7eb' } }, { children: [_jsx(Button, __assign({ id: 'btn-cancelar-assinatura', variant: 'outlined', onClick: handleCancelar, disabled: processando, sx: {
                            fontWeight: 700,
                            color: '#4b5563',
                            borderColor: '#d1d5db',
                            borderRadius: 2,
                            px: 3,
                            backgroundColor: '#ffffff',
                            '&:hover': { backgroundColor: '#f3f4f6', borderColor: '#d1d5db' },
                        } }, { children: "CANCELAR" })), _jsx(Button, __assign({ id: 'btn-confirmar-assinatura', variant: 'contained', onClick: handleAssinarEnviar, disabled: processando, disableElevation: true, startIcon: processando ? _jsx(CircularProgress, { size: 16, color: 'inherit' }) : _jsx(SendIcon, { sx: { fontSize: 16 } }), sx: {
                            fontWeight: 700,
                            backgroundColor: '#16a34a',
                            color: 'white',
                            borderRadius: 2,
                            px: 3,
                            '&:hover': { backgroundColor: '#15803d' },
                            '&.Mui-disabled': {
                                backgroundColor: '#86efac',
                                color: 'white',
                            },
                        } }, { children: processando ? 'PROCESSANDO...' : 'ASSINAR E ENVIAR' }))] }))] })));
}
